import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Check, X, Loader2 } from "lucide-react";
import { useCart } from "@/contexts/CartContext";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("polling");
  const attempts = useRef(0);
  const { refreshCart } = useCart();

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refreshCart();
          return;
        }
        if (data.payment_status === "failed" || data.payment_status === "expired") {
          setStatus("failed"); return;
        }
      } catch { /* keep polling */ }
      attempts.current += 1;
      if (attempts.current > 30) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [params, refreshCart]);

  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center fade-in">
      {status === "polling" && (
        <>
          <Loader2 className="w-12 h-12 text-accent mx-auto animate-spin" />
          <h1 className="mt-6 font-serif text-3xl">Vérification du paiement...</h1>
          <p className="mt-3 text-muted-foreground">Merci de patienter quelques secondes.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="w-16 h-16 mx-auto rounded-full bg-accent/10 text-accent flex items-center justify-center"><Check className="w-8 h-8" /></div>
          <h1 className="mt-6 font-serif text-4xl">Merci !</h1>
          <p className="mt-3 text-muted-foreground">Votre commande est confirmée. Vos livres sont disponibles dans votre bibliothèque.</p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/bibliotheque"><Button data-testid="success-library-btn" className="rounded-sm">Ma bibliothèque</Button></Link>
            <Link to="/catalogue"><Button variant="outline" className="rounded-sm">Continuer</Button></Link>
          </div>
        </>
      )}
      {(status === "failed" || status === "timeout" || status === "error") && (
        <>
          <div className="w-16 h-16 mx-auto rounded-full bg-destructive/10 text-destructive flex items-center justify-center"><X className="w-8 h-8" /></div>
          <h1 className="mt-6 font-serif text-3xl">Paiement non abouti</h1>
          <p className="mt-3 text-muted-foreground">Une erreur s'est produite. Merci de réessayer.</p>
          <Link to="/panier"><Button className="mt-8 rounded-sm">Retour au panier</Button></Link>
        </>
      )}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center fade-in">
      <h1 className="font-serif text-4xl">Paiement annulé</h1>
      <p className="mt-3 text-muted-foreground">Aucun montant n'a été prélevé.</p>
      <Link to="/panier"><Button className="mt-8 rounded-sm">Retour au panier</Button></Link>
    </div>
  );
}
